import type { IconProps } from "./icon-types";

/**
 * 2단 실린더(상단 타원 + 몸통 + 중간 띠) — 데이터베이스/데이터셋/저장소 표시에 사용
 * (제품 의미 부여는 소비 앱의 semantic alias 책임).
 *
 * lucide 류의 일반적인 database 형태를 참고한 커스텀 드로잉 — c6 패키지는 외부 아이콘
 * 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘). 24 그리드 / stroke 기반.
 */
export const DatabaseIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <ellipse cx="12" cy="5" rx="9" ry="3" />
    <path d="M3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5" />
    <path d="M3 12c0 1.66 4.03 3 9 3s9-1.34 9-3" />
  </svg>
);
